import { render, staticRenderFns } from "./TwoNumber.vue?vue&type=template&id=412fc38f&"
import script from "./TwoNumber.vue?vue&type=script&lang=js&"
export * from "./TwoNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports